<template>
<div>

<router-view>
        <slot></slot>
</router-view>

</div>
</template>

<style lang='less'>
#app {
    b, strong {
        font-weight: bold;
    }
}
</style>

<script>
export default {
    created() {
        console.log(this.$slots)
    }
}
</script>